






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter, namespace } from 'vuex-class';
import { EventBus } from "@/pitprojekt/event-bus";
import GoogleMapDialog from "@/components/dialog/GoogleMapDialog.vue";
import DetailedStatsTable from "@/components/table/DetailedStatsTable.vue";
import { Product } from "@/pitprojekt/models/Product";
import { Utils } from '@/pitprojekt/utils';
import { DataTablePaginatorAndProduct } from "@/store/modules/dashboard/types";
import { ProductAggregatedStatUruchomienia, ProductDetailedStatUruchomienia } from "@/store/modules/statsUruchomienia/types";
import { Pagination } from "@/pitprojekt/types";
import { StatsTableHeaders } from '@/views/elements/stats-table-headers'
const StatsUruchomieniaModule = namespace('StatsUruchomieniaModule')
const SettingsModule = namespace('SettingsModule')
import { StatsUruchomieniaService } from "@/services/stats-uruchomienia.service"
import _ from 'lodash'

@Component({
    components: { GoogleMapDialog, DetailedStatsTable }
})
export default class StatsUruchomieniaTable extends Vue {
    @SettingsModule.Getter('selectedProduct') selectedProduct!:number;
    @SettingsModule.Getter('selectedProductObject') selectedProductObject!:Product;
    @SettingsModule.Getter('lastYear') lastYear!:boolean;
    @StatsUruchomieniaModule.Getter('aggregatedStatsUruchomienia') aggregatedStatsUruchomienia! :Array<object>;
    @StatsUruchomieniaModule.Getter('aggregatedStatsUruchomieniaTotal') aggregatedStatsUruchomieniaTotal! :number;
    @StatsUruchomieniaModule.Getter('aggregatedStatsUruchomieniaLoading') aggregatedStatsUruchomieniaLoading! :number;
    @StatsUruchomieniaModule.Action('getAggregatedStatsUruchomieniaBetweenDatesForProduct') getAggregatedStatsUruchomieniaBetweenDatesForProduct: any;
    @SettingsModule.Action('changeSelectedProduct') changeSelectedProduct: any;
    pagination: Pagination = {};
    expanded: Array<ProductAggregatedStatUruchomienia> = [];
    detailedStatsUruchomienia: Array<ProductDetailedStatUruchomienia> = [];
    deklaracjeKwotaTotal: number = 0;
    deklaracjeCountTotal: number = 0;
    statsFromWindowsPercent: number = 0;
    isDetailedStatsUruchomieniaLoading: boolean = false;
    headers: object = StatsTableHeaders.aggregatedStatsHeader();
    headersIn: object = StatsTableHeaders.detailedStatsUruchomieniaHeader();

    created() {
        this.changeSelectedProduct(this.$route.params.id);
        EventBus.$on('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    beforeDestroy() {
        EventBus.$off('PageTitleDateChangedEvent', this.pageTitleDateChanged);
    }

    goToStatsBrowsing() {
        this.$router.push({ name: 'stats-uruchomienia-details-index', params: { id: ''+this.selectedProduct } });
    }

    pageTitleDateChanged() {
        this.getAggregatedStatsUruchomieniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
    }

    getProductIconName(rodzaj: string): string {
        return Utils.getProductIconName(rodzaj);
    }

    @Watch('selectedProduct')
    onSelectedProductChanged() {
        if (this.$route.params.id != this.selectedProduct.toString()) {
            this.getAggregatedStatsUruchomieniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
            this.$router.push({ name: 'stats-uruchomienia-product', params: { id: ''+this.selectedProduct } });
        }
    }

    @Watch('pagination')
    onPagination() {
        this.getAggregatedStatsUruchomieniaBetweenDatesForProduct(this.dataTablePaginatorAndProduct);
    }

    @Watch('expanded')
    onExpandedChanged() {
        this.detailedStatsUruchomienia = [];
        this.deklaracjeKwotaTotal = 0;
        this.deklaracjeCountTotal = 0;
        this.statsFromWindowsPercent = 0
        this.isDetailedStatsUruchomieniaLoading = true;
        if (this.expanded.length > 0) this.getDetailedStatsUruchomienia();
    }

    get dataTablePaginatorAndProduct(): DataTablePaginatorAndProduct {
        return <DataTablePaginatorAndProduct> {
            'productId' : this.selectedProduct,
            'page': this.pagination.page,
            'itemsPerPage': this.pagination.itemsPerPage,
            'lastYear': this.lastYear
        }
    }

    async getDetailedStatsUruchomienia() {
        this.detailedStatsUruchomienia = await StatsUruchomieniaService.getDetailedListBetweenDates(this.selectedProduct, this.expanded[0].data, this.expanded[0].data, this.lastYear);
        this.isDetailedStatsUruchomieniaLoading = false;
        this.deklaracjeKwotaTotal = _.sumBy(this.detailedStatsUruchomienia, 'deklaracje_kwota');
        this.deklaracjeCountTotal = _.sumBy(this.detailedStatsUruchomienia, 'deklaracje_count');

        this.statsFromWindowsPercent = (_.filter(this.detailedStatsUruchomienia, function(o:ProductDetailedStatUruchomienia) { if (o.os == 'Windows') return o }).length / this.detailedStatsUruchomienia.length) * 100;
    }

    isWeekend(date: string):boolean {
        return Utils.isWeekend(date);
    }

    toggleExpandRow(item:ProductAggregatedStatUruchomienia) {
        this.expanded = item === this.expanded[0] ? [] : [item];
    }

    isRowExpanded(item:ProductAggregatedStatUruchomienia):boolean {
        return (item === this.expanded[0]);
    }

    showGoogleMapDialogByIP(ip: string) {
      EventBus.$emit('showGoogleMapDialogByIPEvent', ip);
    }

}
